<template functional>
  <div class="appt-lfd" :class="props.item.appt_lfd">
    {{ props.item.lfd_fmt }}
  </div>
</template>

<script>
export default {
  name: "fltl-lfd",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
